import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import { Configuration } from "./infrastructure/Configuration";
import { PushCommandClient } from "./infrastructure/NotificationSubscribers";
import { CapabilityName, Role } from "./infrastructure/Constants";
import { CapabilityRegistry, Capabilities } from "./infrastructure/Capabilities";
import { BackSplashComponent } from "./capabilities/BackSplashComponent";
import { LoaderComponent } from "./capabilities/LoaderComponent";
import { ModalComponent } from "./capabilities/ModalComponent";
import { NotificationComponent } from "./capabilities/NotificationComponent";
import { CapabilitiesContext, SettingsContext, UserContext } from "./infrastructure/Contexts";
import { AnonymousTranslationPage } from "./pages/AnonymousTranslationPage";
import { ApiDataAccess } from './infrastructure/ApiDataAccess';

import "./custom.css";
import "/node_modules/flag-icons/css/flag-icons.min.css";


export default function App() {
    const displayName = App.name;
    const capabilities = new CapabilityRegistry();

    const [config, setConfig] = useState(null);
    const [mode, setMode] = useState(0);

    useEffect(() => {
        console.log("Application initializing");

        async function init() {          
            let configuration = new Configuration();
            try {
                var config = await configuration.getConfigAsync();
                if (config) {

                    var notificationClient = new PushCommandClient(config.settings["Notifications:PushWebSocketUri"], config.settings["Security:ClientId"], config.user.sid);
                    var notificationRegistry = notificationClient.getSubscriberRegistry();

                    notificationRegistry.registerHandler(onCommandReceived);

                    var config = {
                        user: config.user,
                        settings: config.settings,
                        capabilities: capabilities,
                        notificationSubscribers: notificationRegistry
                    }
                    setConfig(config);
                    setMode(0);
                }
            }
            catch (ex) {
                console.log("Application initialization has failed. Redirecting to login page.", ex);
                window.location.replace("account/login");
            }
        }

        async function initAnonymous() {
            try {

                const query = new URLSearchParams(window.location.search);
                const token = query.get('auth');

                var dataAccess = new ApiDataAccess('api/access');
                var accessInfo = await dataAccess.get(`/${token}`);                

                var config = {
                    capabilities: capabilities,
                    accessInfo: accessInfo
                };

                setConfig(config);
                setMode(1);

            }
            catch (ex) {
                console.log("Application initialization has failed. Redirecting to login page.", ex);
            }
        }

        var pathname = window.location.pathname;

        if (pathname.toLocaleLowerCase() == '/iframe') {
            initAnonymous();
        }
        else {
            init();
        }

    }, []);

    const onCommandReceived = (command) => {
    }

    const compareableRole = (role) => {
        switch (role) {
            case Role.Novice:
                return 1;
                break;
            case Role.Intermediate:
                return 2;
                break;
            case Role.Advanced:
                return 3;
                break;
            case Role.Professional:
                return 4;
                break;
            default:
                return 0;
                break;
        }
        return 0;
    }


    return (
        <div className="culture">

            <BackSplashComponent capabilityRegistry={capabilities} id={CapabilityName.BackSplash} />
            <LoaderComponent capabilityRegistry={capabilities} id={CapabilityName.Loader} />
            <ModalComponent capabilityRegistry={capabilities} id={CapabilityName.Modal} />
            <NotificationComponent capabilityRegistry={capabilities} id={CapabilityName.Notification} />

            { config && mode == 0 &&
                <SettingsContext.Provider value={config.settings}>
                    <UserContext.Provider value={config.user}>
                        <CapabilitiesContext.Provider value={config.capabilities}>
                                <Layout>
                                    <Routes>
                                        {AppRoutes.map((route, index) => {
                                            const { element, ...rest } = route;
                                            if (compareableRole(config.user.role) >= compareableRole(route.role)) {
                                                return <Route key={index} {...rest} element={element} />;
                                            }
                                        })}
                                    </Routes>
                            </Layout>
                        </CapabilitiesContext.Provider>
                    </UserContext.Provider>
                </SettingsContext.Provider>
            }

            {config && mode == 1 &&
                <CapabilitiesContext.Provider value={config.capabilities}>
                    <AnonymousTranslationPage applicationKey={config.accessInfo.translationClientId} source={config.accessInfo.sourceCultureString} target={config.accessInfo.targetCultureString} />   
                </CapabilitiesContext.Provider>
            }


        </div>
    );
}
